import { z } from 'zod';

//* event type
export const locationTrackingEventTypeSchema = z.enum([
  'motionchange',
  'providerchange',
  'geofence',
  'heartbeat',
  'unknown',
]);
export type LocationTrackingEventType = z.infer<typeof locationTrackingEventTypeSchema>;
